module.exports = __webpack_public_path__ + "img/notifications.d46aabe6.svg";